import { FoodsSelect } from "@foodpilot/foods";
import { useTranslation } from "react-i18next";
import type { ComponentAppearance } from "src/components/appearance";
import { FoodsSelectTriggerAdapter } from "src/components/EntityForm/FoodsSelectTriggerAdapter";

type ComparisonItem = {
    key: string;
    title: string;
};

type ComparisonSelectorProps = {
    items: ComparisonItem[];
    selectedIndex: string;
    onChange: (selectedIndex: string) => void;
    appearance?: ComponentAppearance;
};

export const ComparisonSelector = (props: ComparisonSelectorProps) => {
    const { appearance = "legacy", items, selectedIndex, onChange } = props;
    const { t } = useTranslation();

    const selectedItem = items.find((item) => item.key === selectedIndex);

    const select = (
        <FoodsSelect
            selectedOption={selectedItem || null}
            options={items}
            onChange={(item) => {
                if (item) {
                    onChange(item.key);
                }
            }}
            getId={(item) => item.key}
            getName={(item) => item.title}
            closeOnSelect
            disableSearch
            BoxProps={{
                width: "100%",
            }}
            textOptions={{
                placeholder: t("component.select.placeholder"),
                searchPlaceholder: t("component.select.searchplaceholder"),
                emptyOptionsText: t("component.select.nooptions"),
                defaultValueText: t("component.select.defaultvalue"),
                noResult: t("component.select.noresultfound"),
            }}
        />
    );

    return appearance === "product-v2" ?
            <FoodsSelectTriggerAdapter accessibleLabel={t("distribution_comparison", "Comparison")}>
                {select}
            </FoodsSelectTriggerAdapter>
        :   select;
};
